module.exports = __webpack_public_path__ + "static/media/Project-Medical.f9bb2053.svg";